export default __webpack_public_path__ + "static/assets/ae59d529e51aff94173275fc528bf752.svg";